import { render, staticRenderFns } from "./slutionindex.vue?vue&type=template&id=35fc099c&scoped=true&lang=pug&"
import script from "./slutionindex.vue?vue&type=script&lang=js&"
export * from "./slutionindex.vue?vue&type=script&lang=js&"
import style0 from "./slutionindex.vue?vue&type=style&index=0&id=35fc099c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc099c",
  null
  
)

export default component.exports